<template>
  <div class="period-filter">
    <button
      v-for="opt in periods"
      :key="opt.value"
      type="button"
      :class="['period-btn', { active: selected === opt.value }]"
      @click="select(opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "PeriodFilter",
  props: {
    value: { type: String, default: "month" }
  },
  data() {
    return {
      selected: this.value,
      periods: [
        { value: "7d", label: "7 días" },
        { value: "month", label: "Este mes" },
        { value: "3m", label: "3 meses" },
        { value: "ytd", label: "YTD" }
      ]
    };
  },
  methods: {
    select(val) {
      this.selected = val;
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.period-filter {
  display: flex;
  border: 1px solid #e4eaf6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.period-btn {
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #909399;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  &:hover {
    color: #31355c;
    background: #f7f8f9;
  }
  &.active {
    background: #31355c;
    color: #fff;
    font-weight: 600;
  }
  & + .period-btn {
    border-left: 1px solid #e4eaf6;
  }
}
</style>
